import { date } from '../../../lib/helpers';
import { headers, search } from './attributes';

export default {
  data: () => ({
    search,
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    headers,
    selectedRow: '',
  }),
  computed: {
    flashErrorMessage() {
      return this.$store.state.rbac.mappingCabang.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.rbac.mappingCabang.flashError;
      },
      set() {
        this.$store.commit('rbac/mappingCabang/setFlashErrorMessage', '');
      },
    },
    loading() {
      return this.$store.state.rbac.mappingCabang.loading;
    },
    users() {
      return this.$store.state.rbac.mappingCabang.allMappings;
    },
    totalMappings() {
      return this.$store.state.rbac.mappingCabang.totalMappings;
    },
    totalPage() {
      return this.$store.state.rbac.mappingCabang.totalPage;
    },
    itemsMapping() {
      return this.$store.state.rbac.allMapping;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    viewItem(item, type) {
      this.$router.push(`/rbac-mapping-cabang/${type}/view`);
      this.$store.commit('rbac/mappingCabang/setDetailData', item);
    },

    clearSearch() {
      this.search.kode_cabang = '';
      this.search.kode_wilayah = '';
      this.search.kodepos = '';
      this.getData();
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      this.$store.commit('rbac/mappingCabang/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('rbac/mappingCabang/fetchMappings', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },
  },
};